<form [formGroup]="form" class="user-form">
  <div class="field mb-4">
    <label for="firstname">
      {{ "i18n.shared.fields.firstname" | translate }}
    </label>
    <input id="firstname" type="text" pInputText formControlName="firstname" />
    <app-error-messages [control]="formControls.firstname"></app-error-messages>
  </div>

  <div class="field mb-4">
    <label for="lastname">
      {{ "i18n.shared.fields.lastname" | translate }}
    </label>
    <input id="lastname" type="text" pInputText formControlName="lastname" />
    <app-error-messages [control]="formControls.lastname"></app-error-messages>
  </div>

  <div class="field mb-4">
    <label for="email">
      {{ "i18n.shared.fields.email" | translate }}
    </label>
    <input
      id="email"
      type="email"
      pInputText
      formControlName="email"
      [readOnly]="formControls.userId.value != null"
      [style.background]="formControls.userId.value != null ? '#f8fafc' : ''"
      [style.cursor]="formControls.userId.value != null ? 'not-allowed' : ''"
    />
    <app-error-messages [control]="formControls.email"></app-error-messages>
  </div>

  <div class="field mb-4" *ngIf="!isAdminRoleSelected">
    <label for="clientId">
      {{ "i18n.base.user-management.column-headers.client" | translate }}
    </label>
    <p-dropdown
      id="clientId"
      [options]="clients"
      formControlName="clientId"
      optionLabel="name"
      optionValue="id"
    ></p-dropdown>
    <app-error-messages [control]="formControls.clientId"></app-error-messages>
  </div>

  <div class="field mb-4">
    <label for="phoneNumber">
      {{ "i18n.shared.fields.phone" | translate }}
    </label>
    <input
      id="phoneNumber"
      type="text"
      pInputText
      formControlName="phoneNumber"
      placeholder="12-digit phone number"
      (keypress)="onPhoneKeyPress($event)"
      (paste)="onPhonePaste($event)"
    />
    <app-error-messages
      [control]="formControls.phoneNumber"
    ></app-error-messages>
  </div>

  <div class="field mb-4" *ngIf="showRoleDropdown">
    <label>
      {{ "i18n.base.user-management.column-headers.role" | translate }}
    </label>
    <p-dropdown
      [options]="roles"
      optionLabel="label"
      optionValue="value"
      [ngModel]="formControls.roles.value?.[0] ?? null"
      [ngModelOptions]="{ standalone: true }"
      (onChange)="onRoleChange($event.value)"
    ></p-dropdown>
    <app-error-messages [control]="formControls.roles"></app-error-messages>
  </div>

  <div class="field mb-4" *ngIf="showSubscriptionDropdown">
    <label for="subscriptionId"> Subscription Plan </label>
    <p-dropdown
      id="subscriptionId"
      [options]="subscriptions"
      formControlName="subscriptionId"
      optionLabel="name"
      optionValue="id"
      placeholder="Select subscription plan"
      [showClear]="true"
    ></p-dropdown>
    <small *ngIf="currentSubscriptionName" class="text-muted">
      Current: {{ currentSubscriptionName }}
    </small>
  </div>

  <div class="field mb-4" *ngIf="showClientAdminCheckbox">
    <p-checkbox
      [binary]="true"
      [ngModel]="formControls.roles.value?.includes(2)"
      [ngModelOptions]="{ standalone: true }"
      (onChange)="toggleClientAdmin($event.checked)"
    ></p-checkbox>
    <label for="isClientAdmin" class="ml-2" style="margin-left: 8px">
      Is Client Admin
    </label>
  </div>

  <div class="field mb-4" *ngIf="showDeliveryExecCheckbox">
    <div class="delivery-exec-row">
      <p-checkbox
        [binary]="true"
        [ngModel]="formControls.roles.value?.includes(6)"
        [ngModelOptions]="{ standalone: true }"
        (onChange)="toggleDeliveryExec($event.checked)"
      ></p-checkbox>
      <label class="ml-2" style="margin-left: 8px">Is Delivery Executive</label>
    </div>

    <div class="delivery-exec-warning" *ngIf="deliveryExecRemovalWarning">
      <i class="pi pi-exclamation-triangle warning-icon"></i>
      <span>
        This user is assigned as a Delivery Executive. Removing this role will
        fail if they still have active delivery plans. Please complete or
        reassign all deliveries first.
      </span>
    </div>
  </div>

  <div class="field-checkbox">
    <p-checkbox
      formControlName="enabled"
      [binary]="true"
      inputId="enabled"
    ></p-checkbox>
    <label for="enabled" style="margin-left: 8px">Enable</label>
  </div>
</form>
